module.exports = __webpack_public_path__ + "img/tip2.9eaff56a.svg";